import React, { ReactElement } from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

interface SidebarPanelHeaderProps {
  icon: ReactElement;
  title: string;
  infoTooltip?: string;
  actionButtons?: ReactElement[];
  titleVariant?: 'default' | 'custom';
  sx?: Record<string, any>;
}

const SidebarPanelHeader: React.FC<SidebarPanelHeaderProps> = ({
  icon,
  title,
  infoTooltip,
  actionButtons,
  titleVariant = 'default',
  sx = {}
}) => {
  const defaultTitleStyles = {
    fontWeight: 600,
    color: (theme: any) => theme.customColors?.themeNeutralPrimaryColor,
    mb: 0.5
  };

  const titleStyles = titleVariant === 'custom' ? defaultTitleStyles : {};

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent={actionButtons ? 'space-between' : 'flex-start'}
      gap={1}
      sx={{ mb: 2, ...sx }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {React.cloneElement(icon, {
            sx: { fontSize: '24px', color: 'text.primary' }
          })}
        </Box>
        <Typography variant="h6" sx={titleStyles}>
          {title}
        </Typography>
        {infoTooltip && (
          <Tooltip title={infoTooltip} arrow placement="top">
            <IconButton size="small" sx={{ color: 'text.secondary' }}>
              <InfoIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      {actionButtons && actionButtons.length > 0 && (
        <Box display="flex" alignItems="center" gap={0.5}>
          {actionButtons.map((button, index) => (
            <React.Fragment key={index}>{button}</React.Fragment>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default SidebarPanelHeader;
